import api from '../services/api';
import { fechaAR } from './dateUtils';

// Oferta de mantenimiento preventivo (20-oct-2026): Radar y "Cerca de este trabajo".
// La app nunca le escribe sola al cliente: arma el mensaje y abre el WhatsApp de la empresa;
// el admin lo revisa y lo manda. Al abrirlo queda registrado "Ofrecido" (backend: ordenes/radar.py).

export const OFERTA_DEFECTO = { ofertaDescuento: 10, ofertaVigenciaDias: 15 };

let cacheConfig = null;
export async function leerOferta() {
    if (cacheConfig) return cacheConfig;
    try {
        const r = await api.get('/rentabilidad/config');
        cacheConfig = {
            ofertaDescuento: Number(r.data?.ofertaDescuento ?? OFERTA_DEFECTO.ofertaDescuento),
            ofertaVigenciaDias: Number(r.data?.ofertaVigenciaDias ?? OFERTA_DEFECTO.ofertaVigenciaDias),
        };
    } catch { cacheConfig = { ...OFERTA_DEFECTO }; }
    return cacheConfig;
}
export async function guardarOferta(cambios) {
    const r = await api.put('/rentabilidad/config', cambios);
    cacheConfig = { ofertaDescuento: Number(r.data.ofertaDescuento), ofertaVigenciaDias: Number(r.data.ofertaVigenciaDias) };
    return cacheConfig;
}

// Meses completos desde yyyy-mm-dd hasta hoy
function mesesDesde(iso) {
    if (!iso) return null;
    const [a, m, d] = String(iso).slice(0, 10).split('-').map(Number);
    const h = new Date();
    return (h.getFullYear() - a) * 12 + (h.getMonth() + 1 - m) - (h.getDate() < d ? 1 : 0);
}

const primerNombre = (n) => {
    const t = String(n || '').trim();
    // Empresas o nombres con varias palabras en mayúscula: se usa entero
    return /\b(SA|SRL|S\.A\.|S\.R\.L\.)\b/i.test(t) ? t : t.split(/\s+/)[0] || '';
};
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
// "el jueves 23/10" a partir de yyyy-mm-dd (sin new Date sobre el texto: en Argentina corre un día)
export function diaVisita(iso) {
    if (!iso) return '';
    const [a, m, d] = String(iso).slice(0, 10).split('-').map(Number);
    const f = new Date(a, m - 1, d);
    return `el ${DIAS[f.getDay()]} ${String(d).padStart(2, '0')}/${String(m).padStart(2, '0')}`;
}

/**
 * Mensaje para el cliente.
 *  tipo: 'FILTRO' | 'SANITIZACION'
 *  cliente: nombre; fechaUltimo: yyyy-mm-dd del último trabajo (o cambio de filtro)
 *  zona: '' o "el jueves 23/10" → "vamos a estar por tu zona"
 */
export function mensajeOferta({ cliente, tipo, fechaUltimo, oferta = OFERTA_DEFECTO, zona = '' }) {
    const hola = `¡Hola${primerNombre(cliente) ? ` ${primerNombre(cliente)}` : ''}! Te escribimos de Dispenser La Tienda.`;
    const que = tipo === 'FILTRO' ? 'el cambio de filtro' : 'la limpieza y sanitización';
    const desde = fechaUltimo ? ` (el último fue el ${fechaAR(fechaUltimo)})` : '';
    const m = mesesDesde(fechaUltimo);
    const tiempo = m == null ? null : m >= 12 ? (Math.floor(m / 12) === 1 ? 'un año' : `${Math.floor(m / 12)} años`) : `${m} meses`;
    const motivo = tipo === 'FILTRO'
        ? `${tiempo && m >= 12 ? `Ya pasó ${tiempo}` : 'Ya está por cumplirse un año'} desde el último cambio de filtro de tu dispenser${desde}, y se recomienda cambiarlo una vez por año para que el agua salga bien.`
        : `${tiempo ? `Ya ${m === 1 ? 'pasó' : 'pasaron'} ${tiempo}` : 'Pasó un tiempo'} desde el último mantenimiento de tu dispenser${desde}, y se recomienda limpiarlo y sanitizarlo cada 6 meses.`;
    const dto = Number(oferta.ofertaDescuento) > 0
        ? ` Si lo coordinamos en los próximos ${oferta.ofertaVigenciaDias} días, tenés un ${oferta.ofertaDescuento}% de descuento.` : '';
    if (zona) {
        return `${hola} ${zona.charAt(0).toUpperCase()}${zona.slice(1)} vamos a estar por tu zona. ${motivo} ¿Aprovechamos para hacerle ${que}?${dto}`;
    }
    return `${hola} ${motivo} ¿Coordinamos una visita para hacerle ${que}?${dto}`;
}

// Número argentino para wa.me (mismo criterio que el aviso al cliente de las visitas)
export function numeroWhatsApp(tel) {
    let n = String(tel || '').replace(/\D/g, '');
    if (!n) return null;
    if (n.startsWith('0')) n = n.slice(1);
    if (n.startsWith('15') && n.length === 10) n = `11${n.slice(2)}`;
    if (!n.startsWith('54')) n = `549${n}`;
    return n;
}

/** Abre WhatsApp con el mensaje y registra la oferta. Devuelve la fecha registrada (o null). */
export async function ofrecerPorWhatsApp({ telefono, mensaje, clienteId, sedeId = null, tipo, origen }) {
    const num = numeroWhatsApp(telefono);
    window.open(num ? `https://wa.me/${num}?text=${encodeURIComponent(mensaje)}` : `https://wa.me/?text=${encodeURIComponent(mensaje)}`, '_blank');
    try {
        const r = await api.post('/radar/ofrecido', { clienteId, sedeId, tipo, origen });
        return r.data?.ofrecidoEn || new Date().toISOString();
    } catch { return null; }
}

/** "hoy", "hace 3 días"… para la marca de Ofrecido */
export function haceCuanto(fechaHora) {
    if (!fechaHora) return '';
    const dias = Math.floor((Date.now() - new Date(fechaHora).getTime()) / 86400000);
    return dias <= 0 ? 'hoy' : dias === 1 ? 'ayer' : `hace ${dias} días`;
}
